import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useMappingChartsDataContext } from './hooks/useMappingChartsDataContext';

export const EvolutionTeam = () => {
    const { chartData } = useMappingChartsDataContext();

    return (
        <Donut
            title={'Paciente por equipe vinculada'}
            subtitles={chartData?.evolutionTeam?.map((item) => item.description)}
            chartData={chartData?.evolutionTeam || []}
            colors={defaultColors.slice(0, chartData?.evolutionTeam?.length) || []}
            height={400}
        />
    );
};
